import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { GoChevronRight } from "react-icons/go";

function Vacanciesimg() {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  const imageStyle = {
    objectFit: 'cover',
    width: '100%', // Adjusted to make the image responsive
    maxHeight: '100vh', // Added to limit the image height on small screens
    // filter: 'opacity(1.8) brightness(2.8)',
  };

  const containerStyle = {
    marginBottom: '10px',
    marginTop: '10px',
    position: 'relative',
    maxWidth: '100%',
    overflow: 'hidden', // Added to hide overflowing content
  };

  const contentContainerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    color: 'white',
  };

  const buttonStyle = {
    fontSize: '16px',
    fontWeight: 600,
    marginTop:'1px',
    border: 'none',
    backgroundColor: isHovered ? "#F7F9FF" : "#FFE114",
    color: isHovered ? "black" : "black",
    transition:"background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s",
    transform: isHovered ? "translateX(10px)" : "translateX(0)",
  };
  const mobileCaptionButtonStyle = {
    backgroundColor: '#FFE114',
    fontSize: '12px',
    fontWeight: 400,
    color: "black",
    marginTop:'-2px',
    padding: '1px',
};
  return (
    <Container fluid style={{ margin: '-18px 0 0 0', padding: 0, position: 'relative' }}>
      <div style={containerStyle}>
        <img
          src={process.env.PUBLIC_URL + '/assets/images/VacancyPage.png'}
          className="d-block w-100" // Added img-fluid for responsiveness
          alt=""
          style={imageStyle}
        />
        <div style={contentContainerStyle}>
         <h3 className="text-lg captionTextStyle" > Your Next Opportunity Awaits </h3>
        <span className="d-none d-xl-block">
         <div style={{marginTop:'50px'}}>
            <Button
              margin={5}
              padding={5}
              variant="warning"
              size="lg"
              active
              style={{mobileCaptionButtonStyle, ...buttonStyle}}
              href="/Vacancies" // Add the desired URL here
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >&nbsp;&nbsp;
              View Job Vacancies{" "}&nbsp;&nbsp;
              <span style={{ fontSize: "20px" }}>
                <GoChevronRight />
              </span>&nbsp;&nbsp;
            </Button>{" "}
            </div>
            </span>
        </div>
      </div>
    </Container>
  );
}

export default Vacanciesimg;